<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="display: flex !important;" [ngClass]="{direction_ltr:dir == 'ltr'}">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" [ngClass]="{search_box_ltr:dir == 'ltr',en:lang == 2}" name="search_all"
            [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)" placeholder="{{ messageService.get_search() }}"
            autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}" class="service_pager"
            [ngClass]="{service_pager_en:dir == 'ltr'}">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="new1" (click)='change_task(1,1,"",1,"",0)' [disabled]='new_status'>
                    <span>{{ messageService.get_new() }}</span>
                </button>
                <button class="search1" (click)='change_task(3,3,"",1,"",0)'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <span (click)='check_access(4, 1, 0, 1, 1)' class="cursor">
                    <mat-icon style="vertical-align:bottom">refresh</mat-icon>
                </span>
                <div class="pager_pe" [ngClass]="{pager_en:dir == 'ltr'}">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox" [ngClass]="{pager_checkbox_en:lang == 2}">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="content-body control-content-body" [ngClass]="{content_body_en:dir=='ltr'}"
    (window:resize)="change_resize()">

    <mat-table [dataSource]="dataSource" class='table-scroll mat_table_fa_without_scroll pe1'
        [ngClass]="{mat_table_en_without_scroll:dir=='ltr',en1:dir == 'ltr'}">
        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'>
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px' [ngClass]="{'en':dir == 'ltr'}">{{ i +
                page_number_first }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">شماره قفسه</span>
                <span *ngIf="lang == 2">Shelf no</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{'en':dir == 'ltr'}"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                {{ x.repairman_shelf_title }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sort">
            <mat-header-cell *matHeaderCellDef [hidden]="true">
                <span *ngIf="lang == 1">ترتیب</span>
                <span *ngIf="lang == 2">Sort</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [hidden]="true" [ngClass]="{'en':dir == 'ltr'}">{{
                x.repairman_shelf_sort }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">وضعیت قفسه</span>
                <span *ngIf="lang == 2">Shelf status</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{'en':dir == 'ltr'}"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                <span>{{ x.repairman_shelf_status_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="customer">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">نام مشتری</span>
                <span *ngIf="lang == 2">Client name</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{'en':dir == 'ltr'}"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                <span>{{ x.customer }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="device">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">دستگاه</span>
                <span *ngIf="lang == 2">Device</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{'en':dir == 'ltr'}"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                <span>{{ x.wharehouse_device_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="brand">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">برند</span>
                <span *ngIf="lang == 2">Brand</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{'en':dir == 'ltr'}"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                <span>{{ x.repairman_brand_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="model">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">مدل</span>
                <span *ngIf="lang == 2">Model</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                <span [ngClass]="{'en':dir == 'ltr'}">{{ x.repairman_model_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="reception">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">شناسه پذیرش</span>
                <span *ngIf="lang == 2">Reception code</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                <span [ngClass]="{'en':dir == 'ltr'}">{{ x.repairman_reception_id2 }}</span>
            </mat-cell>
        </ng-container>


        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">شناسه</span>
                <span *ngIf="lang == 2">Code</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{'en':dir == 'ltr'}"
                (click)='change_task(2,x.repairman_shelf_id,x.repairman_shelf_title,x.repairman_shelf_shstatus,x.repairman_shelf_sort,x.repairman_reception_shelf)'>
                {{ x.repairman_shelf_id }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="log">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">لاگ قفسه</span>
                <span *ngIf="lang == 2">Shelf log record</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{'en':dir == 'ltr'}">
                <span (click)="open_log(x.repairman_shelf_id)">
                    <i class="fa fa-eye icon"></i>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:70px'>
                <span *ngIf="lang == 1">عملیات</span>
                <span *ngIf="lang == 2">Operation</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>
                <span (click)="check_access(3,0,x.repairman_shelf_id,0,1)"><i class="far fa-trash-alt icon"
                        style='margin:0px 4px;'></i></span>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
        <mat-row *matRowDef="let row;columns:displayedColumns;let i = index" (click)="mat_table_selectedRow = row"
            (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor" [ngStyle]="{'background':row.repairman_shelf_status_color}"></mat-row>

    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview2.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>

</div>


<ngx-smart-modal #myModal identifier="myModal" class="pe" (onClose)="ModalClose()">
    <form [formGroup]="form1_group">
        <div class="dialog_title1">
            <span>{{ messageService.get_title(type_task) }}</span>
        </div>
        <div class="row">
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{'full-left':dir == 'ltr'}"
                [hidden]="type_task == 1">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره قفسه - فقط عدد </span>
                    <span *ngIf="lang == 2"> Shelf no - number only </span>
                    <input class='wh-input' formControlName="title" autocomplete="off" [ngClass]="{'en':dir == 'ltr'}"
                        [required]="required() && type_task == 2">
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{'full-left':dir == 'ltr'}"
                [hidden]="type_task == 2">
                <label for="title" class='wh-label'>
                    <span> تعداد قفسه تعمیرگاه- بین 1 تا 200 </span>
                    <input class='wh-input' formControlName="number" length="200" max="200" maxlength="3"
                        autocomplete="off" [ngClass]="{'en':dir == 'ltr'}" [required]="required() && type_task == 1">
                </label>
                <span class="text-muted" style="font-size: 12px;">حداکثر تعداد قابل تعریف 200 عدد</span>
            </div>


            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{'full-left':dir == 'ltr'}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب </span>
                    <span *ngIf="lang == 2"> Sort </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off" [ngClass]="{'en':dir == 'ltr'}">
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{'full-left':dir == 'ltr'}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت قفسه </span>
                    <span *ngIf="lang == 2"> Shelf status </span>
                    <select class='wh-input' formControlName="status_id" [required]="true"
                        [ngClass]="{'en':dir == 'ltr'}">
                        <option *ngFor='let x of list_status' value="{{ x.repairman_shelf_status_id }}">
                            <span>{{ x.repairman_shelf_status_title }}</span>
                        </option>
                    </select>
                </label>
            </div>
        </div>
        <div class="row">
            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center'>
                <button class="btn_pe" (click)="check_access(type_task,0,0,0,1)" [disabled]="!form1_group.valid">
                    {{ messageService.get_event_title(type_task) }}
                </button>
            </div>
        </div>
    </form>
</ngx-smart-modal>

<ngx-smart-modal #myModalSearch identifier="myModal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
    <form [formGroup]="form1_search_group">
        <div class="dialog_title1">
            <span>{{ messageService.get_title(type_task) }}</span>
        </div>
        <div class="row">
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'>
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره قفسه </span>
                    <span *ngIf="lang == 2"> Shelf no </span>
                    <input class='wh-input' formControlName='title_search' autocomplete="off"
                        [ngClass]="{'en':dir == 'ltr'}">
                </label>
            </div>
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="status_id_search" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعيت نمايش </span>
                    <span *ngIf="lang == 2"> Display status </span>
                    <select class='wh-input' formControlName='status_id_search' pattern="[0-9]{1,}"
                        [ngClass]="{'en':dir == 'ltr'}">
                        <option value=""></option>
                        <option *ngFor='let x of list_status' value="{{ x.repairman_shelf_status_id }}">
                            <span>{{ x.repairman_shelf_status_title }}</span>
                        </option>
                    </select>
                </label>
            </div>

        </div>
        <div class="row">
            <div class='col-xl-12 col-lg-12  col-md-12  col-sm-12 col-xs-12'
                style='margin-top:5px;text-align:center;font-family:irsans'>
                <button class="btn_pe" (click)="check_access(4,1,0,1,1)">
                    {{ messageService.get_event_title(type_task) }}
                </button>
            </div>
        </div>
    </form>
</ngx-smart-modal>